import { Routes, Route, Link } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { FaTimes } from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import Home from './components/Home';
import About from './components/Aboutus';
import Ourservices from './components/Ourservices';
import Ourplan from './components/Ourplan';
import Joining from './components/Joining';
import OurManuFacturing from './components/OurManuFacturing';
import './styles/Navbar.css';

function App() {
  const navRef = useRef();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading && window.location.pathname === '/') {
      const timer = setTimeout(() => setIsLoading(false), 2000);
      return () => clearTimeout(timer);
    } else {
      setIsLoading(false);
    }
  }, [isLoading]);

  const toggleNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-icon-container">
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
          <div className="loading-dot"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header id='header'>
        <div className="home-page3"></div>
        <nav>
          <div className="home-page1">
            <div className="home-page2"></div>
            <div style={{ textAlign: 'center' }}>
              <h1 className="fitness">Global Innovation Technologies</h1>
              <h3 className='imagination'>Imagination Turns to Innovation</h3>
              <h2 className="iso">ISO 9001:2015 CERTIFIED COMPANY</h2>
            </div>
          </div>
          <div className="join">
            <div className="join-us">
              <h3><Link to='/join' id="join">Contact Us</Link></h3>
            </div>
          </div>
        </nav>
      </header>

      <div className="nav-bar">
        <div className="logo2"></div>
        <header id='header2'>
          <div className='homepage-nav' ref={navRef}>
            <div className="home-page3"></div>
            <div className='duplicate'>
              <div id='menu1'>

                <Link to="/" onClick={toggleNavbar}><span id="home">Home</span></Link>
                <Link to="/about" onClick={toggleNavbar}>About</Link>
                <Link to="/product" onClick={toggleNavbar}>Products</Link>
                <Link to="/services" onClick={toggleNavbar}>Services</Link>
                <Link to="/price" onClick={toggleNavbar}>Customers</Link>
              </div>
              <button className="nav-btn nav-close-btn" onClick={toggleNavbar}>
                <FaTimes />
              </button>
            </div>
          </div>
        </header>
        <button className="nav-btn" onClick={toggleNavbar}>
          <IoMenu id="burger-menu" />
        </button>
      </div>

      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Ourservices />} />
        <Route path="/product" element={<OurManuFacturing />} />
        <Route path="/price" element={<Ourplan />} />
        <Route path="/join" element={<Joining />} />
      </Routes>
    </div>
  );
}

export default App;
